import { ContentSwitcher, Label } from '@iwoca/orion';

import { Trans } from '@lingui/macro';
import { useLocale } from 'hooks/useLocale';
import { TCalculatorProducts } from 'types';
import {
  MAX_CREDIT_FACILITY_DURATION,
  MAX_FLEXI_24_DURATION,
  MAX_TERM_LOAN_DURATION,
} from '../filterConfigs.helper';
import styles from './ProductFilter.module.css';

type TProps = {
  value: number;
  hasTermLoan?: boolean;
  onChange: (product: TCalculatorProducts, term: number) => void;
};

export const ProductFilter = ({
  value: selectedDuration,
  onChange,
}: TProps) => {
  const { isDE } = useLocale();

  const handleSelected = (duration: string) => {
    onChange(
      // Only set flexi24 product if UK and 24 month duration
      duration === MAX_FLEXI_24_DURATION && !isDE
        ? 'flexi24'
        : 'credit_facility',
      Number(duration),
    );
  };

  return (
    <div className={styles.container}>
      <Label className={styles.label}>
        <Trans>Term length</Trans>
      </Label>
      <ContentSwitcher value={selectedDuration.toString()}>
        <ContentSwitcher.Button
          id={MAX_CREDIT_FACILITY_DURATION}
          setSelected={handleSelected}
        >
          <Trans>12 months</Trans>
        </ContentSwitcher.Button>
        <ContentSwitcher.Button
          id={MAX_FLEXI_24_DURATION}
          setSelected={handleSelected}
        >
          <Trans>24 months</Trans>
        </ContentSwitcher.Button>
        <ContentSwitcher.Button
          id={MAX_TERM_LOAN_DURATION}
          setSelected={handleSelected}
        >
          <Trans>60 months</Trans>
        </ContentSwitcher.Button>
      </ContentSwitcher>
    </div>
  );
};
